var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFBD00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_33_discount_ticket"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,27.5h2.2c0.6,0,1.1-0.5,1.1-1.1v-9c0-1.2-1-2.2-2.2-2.2H2.9c-1.2,0-2.2,1-2.2,2.2v9c0,0.6,0.5,1.1,1.1,1.1 H4c2.5,0,4.5,2,4.5,4.5s-2,4.5-4.5,4.5c0,0,0,0,0,0H1.7c-0.6,0-1.1,0.5-1.1,1.1v9c0,1.2,1,2.2,2.2,2.2h58.3c1.2,0,2.2-1,2.2-2.2v-9 c0-0.6-0.5-1.1-1.1-1.1H60c-2.5,0-4.5-2-4.5-4.5C55.5,29.5,57.5,27.5,60,27.5C60,27.5,60,27.5,60,27.5z M60,38.7h1.1l0,7.9l-58.3,0 v-7.9H4c3.7,0,6.7-3,6.7-6.7s-3-6.7-6.7-6.7H2.8l0-7.9l58.3,0v7.9H60c-3.7,0-6.7,3-6.7,6.7S56.3,38.7,60,38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,19.7c-0.6,0-1.1,0.5-1.1,1.1V23c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1v-2.2C33.1,20.2,32.6,19.7,32,19.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,39.9c-0.6,0-1.1,0.5-1.1,1.1v2.2c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1V41C33.1,40.4,32.6,39.9,32,39.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,33.1c-0.6,0-1.1,0.5-1.1,1.1v2.2c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1v-2.2C33.1,33.6,32.6,33.1,32,33.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,26.4c-0.6,0-1.1,0.5-1.1,1.1v2.2c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1v-2.2C33.1,26.9,32.6,26.4,32,26.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.2,26.4h4.5c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1h-4.5c-0.6,0-1.1,0.5-1.1,1.1S14.6,26.4,15.2,26.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.2,33.1h6.7c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1h-6.7c-0.6,0-1.1,0.5-1.1,1.1S14.6,33.1,15.2,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.2,37.6h-9c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1h9c0.6,0,1.1-0.5,1.1-1.1S24.8,37.6,24.2,37.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.8,24.2c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3c1.8,0,3.3-1.5,3.3-3.3 C43.2,25.7,41.7,24.2,39.8,24.2z M39.8,28.7c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1 C41,28.1,40.5,28.7,39.8,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.8,33.1c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3c0,0,0,0,0,0 C52.1,34.6,50.7,33.1,48.8,33.1z M48.8,37.6c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0,0,0,0,0,0c0.6,0,1.1,0.5,1.1,1.1 C50,37.1,49.4,37.6,48.8,37.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.7,25.6c-0.4-0.4-1.1-0.4-1.6,0L37.9,36.8c-0.4,0.4-0.4,1.1,0,1.6c0.4,0.4,1.1,0.4,1.6,0l11.2-11.2 C51.1,26.7,51.1,26,50.7,25.6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferral);
export default __webpack_public_path__ + "static/media/referral.0e973c3ef1e787e303be5b1532620b94.svg";
export { ForwardRef as ReactComponent };